import { Flexbox, Sizes } from '@sede-enterprise/shell-ds-react-framework';
import { DynatraceTriggerAction } from 'components/DynatraceTriggerAction/dynatrace-trigger-action';
import { Skeleton } from 'components/storybook-migration/skeleton/Skeleton';
import { DYNATRACE_ACTIONS } from 'constants/dynatrace-actions';
import {
  CardStyled,
  SuffixPrefix,
  SummaryCardMainText,
  SummaryCardWrapper,
} from 'pages/Optimisation/components/SummaryCards/SummaryCard.styled';
import { SummaryCardTitle } from 'pages/Optimisation/components/SummaryCards/SummaryCardTitle/SummaryCardTitle';
import { SummaryCardProps } from 'pages/Optimisation/types';
import { useDynatraceTriggerAction } from 'utils/dynatrace';

const TooltipText = () => {
  useDynatraceTriggerAction(
    DYNATRACE_ACTIONS.TOOLTIP_TOTAL_REVENUE_PER_INSTALLED_MW,
  );
  return (
    <p>
      Your net total revenue divided by your site capacity for the time period
      selected.
    </p>
  );
};

export const RevenuePerMWCard = ({
  data,
  loading,
  marketFilter,
}: SummaryCardProps) => {
  const value = data?.site?.tradeSummary?.[
    marketFilter
  ]?.averagePoundPerMW?.toLocaleString('en-GB', {
    maximumFractionDigits: 0,
  });

  return (
    <CardStyled size={Sizes.Small}>
      <SummaryCardWrapper>
        <SummaryCardTitle
          title={'Net revenue per installed MW'}
          tooltip={<TooltipText />}
        />

        <div>
          {!data || loading ? (
            <div style={{ marginTop: 12 }}>
              <Skeleton data-testid="skeleton" width="230px" height="35px" />
            </div>
          ) : (
            <Flexbox
              alignItems={'baseline'}
              data-testid={'summary-card-main-text'}
            >
              <SummaryCardMainText>{value}</SummaryCardMainText>
              <SuffixPrefix> £/MW</SuffixPrefix>
            </Flexbox>
          )}
        </div>
      </SummaryCardWrapper>
    </CardStyled>
  );
};
